import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex pa-4" }
const _hoisted_3 = { class: "ml-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "pt-6" }
const _hoisted_12 = { class: "class-diary-label" }
const _hoisted_13 = { class: "class-diary-label" }
const _hoisted_14 = { class: "class-diary-content" }
const _hoisted_15 = { class: "class-diary-label" }
const _hoisted_16 = { class: "class-diary-content" }
const _hoisted_17 = { class: "class-diary-label" }
const _hoisted_18 = { class: "class-diary-content" }
const _hoisted_19 = { class: "my-8" }
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_ctx.diary)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_breadcrumbs, {
            class: "px-0",
            items: [
          { title: 'School Diary', href: '/school-diary', color: 'primary' },
          { title: _ctx.dateLabel },
        ]
          }, null, 8, ["items"])
        ]),
        (_ctx.isUpdating || _ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary",
              class: "my-8"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.dateLabel), 1),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isApproved || _ctx.isApprovedByChief)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_v_chip, {
                    color: "primary",
                    dark: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.approved')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.applicationStatus === 'applied')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createVNode(_component_v_chip, {
                      color: "primary",
                      variant: "outlined",
                      dark: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.applied')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_v_chip, {
                      color: "grey",
                      variant: "outlined",
                      dark: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.draft')), 1)
                      ]),
                      _: 1
                    })
                  ]))
          ]),
          _createVNode(_component_v_spacer),
          (!_ctx.isApproved)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "grey",
                class: "mr-4",
                variant: "outlined",
                "x-large": "",
                onClick: _ctx.saveAsDraft,
                disabled: _ctx.isUpdating
              }, {
                default: _withCtx(() => [
                  (_ctx.isDraft)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('schoolDiary.saveAsDraft')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('schoolDiary.returnDraft')), 1))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.isDraft)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                color: "primary",
                variant: "flat",
                "x-large": "",
                onClick: _ctx.saveAndApply,
                disabled: _ctx.isUpdating || _ctx.appliedBy === null
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.saveAndApply')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          ((_ctx.isDirector || _ctx.isChief) && _ctx.isApplied)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  "x-large": "",
                  class: "ml-2",
                  disabled: _ctx.isUpdating || _ctx.isApprovedByMe,
                  onClick: _ctx.approve
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.approve')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (
          (_ctx.isChief && _ctx.isApplied && _ctx.isApprovedByChief) ||
          (_ctx.isDirector && _ctx.isApplied && _ctx.isApproved)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "error",
                  large: "",
                  class: "ml-2",
                  disabled: _ctx.isUpdating,
                  onClick: _ctx.reject
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.revokeApproval')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: _ctx.$t('settings.director'),
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.directorApproveStamp
                }, null, 8, ["label", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: _ctx.$t('settings.chief'),
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.cheifApproveStamp
                }, null, 8, ["label", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  variant: "outlined",
                  label: _ctx.$t('schoolDiary.applicant'),
                  items: _ctx.staffOptions,
                  "item-value": "userId",
                  "item-title": "name",
                  modelValue: _ctx.appliedBy,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appliedBy) = $event))
                }, null, 8, ["label", "items", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('schoolDiary.title')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('schoolDiary.classDiaryList')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diary.classDiaries, (cd) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              key: cd.classDiaryId,
              variant: "outlined",
              class: "pa-4 mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('common.class')), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.getClassName(cd.classId)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('schoolDiary.todaysAim')), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(cd.aim), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('schoolDiary.mainActivityAM')), 1),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(cd.activityAm), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('schoolDiary.mainActivityPM')), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(cd.activityPm), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('schoolDiary.absentees')), 1),
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('schoolDiary.childName')), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('schoolDiary.className')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diary.absentees, (child) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: child.childId
                  }, [
                    _createElementVNode("td", null, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getCurrentClass(child)), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('schoolDiary.freeNotes')), 1),
                _createVNode(_component_v_textarea, {
                  readonly: _ctx.isApproved || _ctx.isApplied,
                  variant: "outlined",
                  modelValue: _ctx.comment,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment) = $event))
                }, null, 8, ["readonly", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('schoolDiary.schoolEvents')), 1),
                _createVNode(_component_v_textarea, {
                  readonly: _ctx.isApproved || _ctx.isApplied,
                  variant: "outlined",
                  modelValue: _ctx.event,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.event) = $event))
                }, null, 8, ["readonly", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('schoolDiary.earlyLeavers')), 1),
                _createVNode(_component_v_textarea, {
                  readonly: _ctx.isApproved || _ctx.isApplied,
                  variant: "outlined",
                  modelValue: _ctx.earlyLeaver,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.earlyLeaver) = $event))
                }, null, 8, ["readonly", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          (_ctx.isUpdating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-8"
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}